import {Locales} from '@netx/core-next/locales/utils/Locales';

export const BreadcrumbLabels = Locales((i18n) => ({
	SHOW_MORE: i18n('i18n.showMore'),
}));
